import { useCallback } from "react";

import { useLanguage } from "@/contexts/LanguageContext";
import { t as translate, type Locale } from "@/i18n/lang";

export { lang, getLang, t, type Locale, type LangMessages } from "@/i18n/lang";

/** 绑定当前 locale 的翻译函数，组件内直接 lt("home.heroTitle") */
export function useT() {
  const { locale } = useLanguage();
  return useCallback((key: string) => translate(locale, key), [locale]);
}

/** 不依赖 Context 的翻译（用于静态配置等场景） */
export function createT(locale: Locale) {
  return (key: string) => translate(locale, key);
}
